import type {OptionStatusIndicator} from 'platform/components';

import type {GetUsersApiResponse} from '@dms/api/shared';

import type {AssignmentOption} from '../types/AssignmentOption';
import {getUserStatusIndicator} from './getUserStatusIndicator';

type User = GetUsersApiResponse[number];

export const mapUsersToSelectOptions = (
  users: User[],
  getStatusIndicator?: (userId: string) => OptionStatusIndicator | undefined
): AssignmentOption[] =>
  users.map((user) => ({
    label: `${user.firstName} ${user.lastName}`,
    value: user.id,
    statusIndicator: getUserStatusIndicator(user, getStatusIndicator?.(user.id)),
  }));
